// @ts-strict-ignore

import type { Route } from 'vue-router'
import type { GuardResolveFunction } from '../models'

import { mapActions, mapGetters } from 'vuex'

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts'
import { CONTEXT_CONSTS } from '../store/context/context.consts'

export const InsightsMixin = {
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
    }),
  },
  data() {
    return {
      data: undefined,
      contextWatchDisabled: false,
      previousContext: undefined,
    }
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      fetchStatsReport: ANALYTICS_CONSTS.actions.fetchStatsReport,
    }),
    async loadData(cleanData = true, ...args: unknown[]): Promise<void> {
      this.$emit('updateLoading', { visible: true })
      try {
        this.data = await this.fetchData(cleanData, ...args)
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error))
        this.data = undefined
      } finally {
        this.$emit('updateLoading', { visible: false })
      }
    },
    fetchData(cleanData: boolean, ...args: unknown[]): Promise<any> {
      return Promise.resolve()
    },
    async onContextChange(): Promise<void> {
      await this.loadData()
    },
  },
  watch: {
    context: {
      async handler(): Promise<void> {
        if (!this.contextWatchDisabled) {
          await this.onContextChange()
        }
        this.previousContext = { ...this.context }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeRouteLeave(to: Route, from: Route, next: GuardResolveFunction): void {
    this.contextWatchDisabled = true
    next()
  },
}
